import { render, staticRenderFns } from "./Instructors.vue?vue&type=template&id=377dd4a1"
import script from "./Instructors.vue?vue&type=script&lang=js"
export * from "./Instructors.vue?vue&type=script&lang=js"
import style0 from "./Instructors.vue?vue&type=style&index=0&id=377dd4a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports